import * as React from 'react';
import { cn } from 'src/utils/utils';

export interface BoxProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
}

function Box({ as: Component = 'div', className, ...props }: BoxProps) {
  return <Component className={cn(className)} {...props} />;
}

export { Box };
